module.exports = __webpack_public_path__ + "img/Jump Casting128.9742e867.jpg";